const InternshipsEnum = Object.freeze({
  Čeština: 'Pouze ukázat stáže',
  Deutsch: 'Nur Praktika anzeigen',
  Français: 'Stages uniquement',
  Slovenčina: 'Zobraziť len stáže',
  Español: 'Sólo mostrar prácticas',
  English: 'Only Show Internships',
})

export default InternshipsEnum
